import { api } from "../../api/axios";
import type {
  TCompleteProfileRequest,
  TSendOtpRequest,
  TVerifyOtpRequest,
} from "../types";

export const sendOtp = async (params: TSendOtpRequest["payload"]) => {
  return await api.post<TSendOtpRequest["response"]>("/v1/auth/otp/send", {
    phoneNumber: params.phoneNumber,
    fullName: params.fullName,
  });
};

export const verifyOtp = async (params: TVerifyOtpRequest["payload"]) => {
  const { data } = await api.post<TVerifyOtpRequest["response"]>(
    "/v1/auth/otp/verify",
    {
      phoneNumber: params.phoneNumber,
      otp: params.otp,
    }
  );
  return data;
};

export const completeProfile = async (
  params: TCompleteProfileRequest["payload"] & { token: string }
) => {
  const { data } = await api.post<TCompleteProfileRequest["response"]>(
    "/v1/auth/complete-profile",
    {
      fullName: params.fullName,
      style: params.style,
    },
    {
      headers: {
        Authorization: `Bearer ${params.token}`,
      },
    }
  );
  return data;
};
